import type { Variant } from '@scayle/storefront-nuxt'
import { getSizeFromVariant } from '@scayle/storefront-nuxt'
import { getSizeLabel } from '../types/variant'

const useSizeDisplayData = () => {
  const { $i18n } = useNuxtApp()
  const getSizeDisplayData = (variant: Variant) => {
    const sizeCategorySize = getSizeFromVariant(variant, 'sizeCategorySize')

    if (!sizeCategorySize?.value) {
      return getSizeLabel(variant) || ''
    }

    const translatedValue = sizeCategorySize.label.split('|')[1]

    return {
      key: 'selectedSize',
      label: $i18n.t('osp.size'),
      value: sizeCategorySize.label,
      translatedValue,
    }
  }
  return {
    getSizeDisplayData,
  }
}

export default useSizeDisplayData
